<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import CMRCommon from './mixin';
import { mapState } from 'vuex';
import { filter, get, orderBy } from 'lodash';
import { planTypes } from '@/common/constants';
import { isZoomSass } from '@/plans/ADDITIONAL_HOST/utils';
import { pageConfig } from '@/common/service/page-config';

export default {
  name: 'AdditionalCoEditorAddon',
  mixins: [base, CMRCommon],
  for: (args)=> {
    const [,, selectedPlans] = args;
    return isZoomSass(selectedPlans) & (
      pageConfig.editConfig.planType === planTypes.EVENT_SAAS || pageConfig.editConfig.planType === planTypes.EVENT_SAAS_CORE
    );
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        filter(this.planMapFlat, (p) => p.type === planTypes.ADDITIONAL_CO_EDITOR && p.isCurrentCategory),
        ['amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>
